export class ApplicationSettings {
    app_id: string;
    app_name: string;
    descr: string;
    version: string;
    aws: boolean;
    package: string;
    login_type: string; // DEPRECATED
    allow_signup: boolean;
    hasLoginScreen: boolean;
    allowGuest: boolean;
    companyLoginUrl: string;

    constructor(json?: any) {
        if (!(json)) return; // Allow construction of empty instance
        this.app_id = json.app_id || '';
        this.app_name = json.app_name || '';
        this.descr = json.descr || '';
        this.version = json.version || '';
        this.aws = !!json.aws;
        this.package = json.package || '';
        if (json.login_type) {
          this.login_type = json.login_type; // DEPRECATED
          if (json.login_type === 'employee') this.hasLoginScreen = true;
          else if (json.login_type === 'guest') this.hasLoginScreen = false;
        }
        this.hasLoginScreen = json.enable_login_screen;
        if (typeof json.allow_guest != undefined) this.allowGuest = !!json.allow_guest;
        if (typeof json.allow_user_signup != undefined) this.allow_signup = !!json.allow_user_signup;
        if (json.login_company_url) this.companyLoginUrl = json.login_company_url;
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/application/application_settings.model.ts